import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatDividerModule } from '@angular/material/divider';
import { BaseChartDirective } from 'ng2-charts';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReportRoutingModule } from './report-routing.module';
import { ViewNativeSoilReportComponent } from './components/native-soil/view-native-soil-report/view-native-soil-report.component';
import { EditNativeSoilReportComponent } from './components/native-soil/edit-native-soil-report/edit-native-soil-report.component';
import { ViewPrecastReportComponent } from './components/precast/view-precast-report/view-precast-report.component';
import { EditPrecastReportComponent } from './components/precast/edit-precast-report/edit-precast-report.component';
import { ThermalResistivityNativeSoilComponent } from
  './components/native-soil/thermal-resistivity-native-soil/thermal-resistivity-native-soil.component';
import { ThermalResistivityPrecastComponent } from
  './components/precast/thermal-resistivity-precast/thermal-resistivity-precast.component';
import { FigureOrderingPopupComponent } from
  './components/native-soil/figure-ordering-popup/figure-ordering-popup.component';
import { PrecastFigureOrderingPopupComponent } from
  './components/precast/figure-ordering-popup/figure-ordering-popup.component';
import { HistoricalCurvePointsComponent } from
  './components/precast/historical-curve-points/historical-curve-points.component';

@NgModule({
  declarations: [
    ViewNativeSoilReportComponent,
    EditNativeSoilReportComponent,
    ViewPrecastReportComponent,
    EditPrecastReportComponent,
    ThermalResistivityNativeSoilComponent,
    ThermalResistivityPrecastComponent,
    FigureOrderingPopupComponent,
    PrecastFigureOrderingPopupComponent,
    HistoricalCurvePointsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    ReportRoutingModule,
    BaseChartDirective,
    MatSidenavModule,
    MatDialogModule,
    MatDividerModule,
    MatRadioModule,
    MatTableModule,
    MatSliderModule,
    DragDropModule,
  ],
})
export class ReportModule { }
